module.exports = __webpack_public_path__ + "media/images/logos/favicon-3fbe98a961d64bfb21dc1272ae809a65.png";